import { get, isEmpty } from "lodash";
import {
  MdAdd,
  MdAttachFile,
  MdOutlineDelete,
  MdOutlineFileDownload,
} from "react-icons/md";
import { bytesToMB } from "utils/helpers/files";
import Button from "../../Components/Button";
import Input from "../../Components/Input";

const DocumentUpload = ({
  items,
  label,
  onDownload,
  onUpload,
  onFileRemove,
  required = false,
  multiple = false,
}) => {
  return !isEmpty(items) ? (
    <div className="amellis__documents--container">
      {items.map((item, index) => (
        <div
          key={item?.uid || item?.id || index}
          className="amellis__documents"
        >
          <MdAttachFile className="amellis__documents--icon" size={24} />
          <div className="amellis__documents--content">
            <div className="amellis__documents--content--name">
              {item?.name || ""}
            </div>
            <div className="amellis__documents--content--size">{`${
              get(item, "name", "").split(".")[1]
            } ${item?.size ? `| ${bytesToMB(item?.size)} Mo` : ""}`}</div>
          </div>
          <div className="amellis__documents--actions">
            <div
              className="--download --action"
              onClick={() => onDownload(item)}
            >
              <MdOutlineFileDownload size={20} />
            </div>
            <div
              className="--delete --action"
              onClick={() => onFileRemove(item)}
            >
              <MdOutlineDelete size={20} />
            </div>
          </div>
        </div>
      ))}
      {multiple && (
        <div className="amellis__documents--uploader">
          <div className="--content">
            <MdAttachFile className="--icon" size={24} />
            <div className="--name">
              {label}
              {required && (
                <span className="label__amellis--required">{` *`}</span>
              )}
            </div>
          </div>
          <Input
            type="file"
            showUploadList={false}
            fileList={items}
            onUpload={onUpload}
            multiple={multiple}
          >
            <Button type="primary-light" size="small">
              <MdAdd size={20} />
              <span>Ajouter un document</span>
            </Button>
          </Input>
        </div>
      )}
    </div>
  ) : (
    <div className="amellis__documents--uploader">
      <div className="--content">
        <MdAttachFile className="--icon" size={24} />
        <div className="--name">
          {label}
          {required && <span className="label__amellis--required">{` *`}</span>}
        </div>
      </div>
      <Input
        type="file"
        showUploadList={false}
        fileList={items}
        onUpload={onUpload}
        multiple={multiple}
      >
        <Button type="primary-light" size="small">
          <MdAdd size={20} />
          <span>Charger le document</span>
        </Button>
      </Input>
    </div>
  );
};
export default DocumentUpload;
